import React, { useContext } from 'react';
import Wrapper from '@airasia-common/react-dom/components/Wrapper/Wrapper';
import Text from '@airasia-common/react-dom/components/Text/Text';
import styled, { ThemeContext } from 'styled-components';
import { func, string } from 'prop-types';

const FallBackMessageWrapper = styled(Wrapper)`
  background-color: ${({ theme }) => theme.colors.greyDarker};
  padding: 8px 16px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  display: flex;
`;

const FallBackMessageText = styled(Text)`
  color: ${({ theme }) => theme.colors.primaryWhite};
  font-size: 12px;
  line-height: 150%;
  font-weight: 400;
  display: flex;
`;

const FallBackMessage = props => {
  const { message } = props;
  const themeContext = useContext(ThemeContext);
  themeContext.fontSize = themeContext.fontSizes;
  return (
    <FallBackMessageWrapper
      maxWidth={['100%', '296px']}
      position={['fixed', 'absolute']}
      top={['auto', `80px`]}
      right={['auto', '80px']}
      bottom={['24px', 'auto']}
      margin={['0 16px', 0]}
      zIndex={1000}
    >
      <FallBackMessageText>{message}</FallBackMessageText>
    </FallBackMessageWrapper>
  );
};
FallBackMessage.propTypes = {
  message: string,
  onClose: func,
};

export default FallBackMessage;
